import dayjs from 'dayjs';
import React, { FC } from 'react';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';
import { useAppSelector } from '../hooks';
import Modal from './common/Modal/Modal';

interface ModalToChainTimeoutProps {
  isShow: boolean;
  onRequestClose: () => void;
}

const ModalToChainTimeout: FC<ModalToChainTimeoutProps> = ({
  isShow,
  onRequestClose,
}) => {
  const { txCurrentHistory } = useAppSelector(selectBridgeSlice);

  return (
    <Modal
      size="sm"
      isShow={isShow}
      onClose={onRequestClose}
      explanation={
        <>
          The conversion to a To-chain wallet cannot be made. You can get a
          refund from{` `}
          {txCurrentHistory
            ? dayjs(Number(txCurrentHistory.fromChainTimelock) * 1000)
                .utc()
                .format(`YYYY-MM-DD HH:mm:ss`)
            : ``}
          &#40;UTC&#41;, so please try again after processing the refund.
        </>
      }
      footerComponent={
        <button
          onClick={onRequestClose}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalToChainTimeout;
